import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Fires a GA4 page_view on every SPA route change.
 * Works for current routes (/ , /online) and any future routes
 * (e.g. /lu-ft-online, /summer-sessions) without needing further wiring.
 */
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    // Defer slightly so document.title reflects the new route if updated.
    const id = window.setTimeout(() => trackPageView(path), 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
